// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"d7960fb5","232":"05dbd04f","237":"d1a1cd3a","357":"3bf7d210","526":"6fd00b0b","753":"d211117c","854":"f66b655d","872":"9fb2638b"}[chunkId] + ".chunk.js";
};